<template>
    <label class="input-wrapper__title">{{ trans('Choose a shipping method') }}</label>

    <Loading v-if="loading"/>

    <div class="order-page__select-options" v-show="!loading">

        <div v-if="deliveries.world_delivery?.name || $store.state.settings.delivery_city?.get_country?.code === 'US'">
            <div class="order-page__select-option order-page__select-option_active">
                <div class="radio-button">
                    <div style="position: relative;">
                        <input v-model="method" id="world_delivery" name="order[delivery_method]"
                               class="radio-button__input"
                               type="radio"
                               value="world_delivery">
                        <label @click="method = 'world_delivery';pvz = false" for="world_delivery"
                               class="radio-button__label"></label>
                    </div>
                    <span class="radio-button__title">{{ trans("Duty & Tax Inclusive") }}</span>
                </div>

            </div>
            <div class="delivery-method__info" v-if="deliveries.world_delivery">
                <span class="order-page__select-option__description">(Import duties are included. You don’t need to pay any additional fees upon delivery)</span>
                <span class="order-page__select-option__description">{{ deliveries.world_delivery.str }}</span>
                - <span class="delivery-method__price">{{
                    deliveries.world_delivery.price
                }} {{ deliveries.world_delivery.currency_sign }} </span>


            </div>
            <div class="delivery-method__info" v-else>
                <span class="order-page__select-option__description"></span>
                <span class="order-page__select-option__description">{{ trans('Not defined') }}</span>
            </div>
        </div>
        <div v-if="deliveries.world_delivery_tax?.name && $store.state.settings.delivery_city?.get_country?.code != 'US'">
            <div class="order-page__select-option order-page__select-option_active">
                <div class="radio-button">
                    <div style="position: relative;">
                        <input v-model="method" id="world_delivery_tax" name="order[delivery_method]"
                               class="radio-button__input"
                               type="radio"
                               value="world_delivery_tax">
                        <label @click="method = 'world_delivery_tax';pvz = false" for="world_delivery_tax"
                               class="radio-button__label"></label>
                    </div>
                    <span class="radio-button__title">{{ trans("Duty & Tax Exclusive") }}</span>
                </div>

            </div>

            <div class="delivery-method__info" v-if="deliveries.world_delivery_tax">
                <span class="order-page__select-option__description">({{
                        trans("Import duties are excluded. You are responsible for paying any duties and taxes based on the import regulations of your country/territory")
                    }})</span>
                <span class="order-page__select-option__description">{{ deliveries.world_delivery_tax.str }}</span>
                <template v-if="deliveries.world_delivery_tax.inclusive">
                    - <span class="delivery-method__price color-red">{{
                        deliveries.world_delivery_tax.price
                    }} {{ deliveries.world_delivery_tax.currency_sign }}
                </span>
                    <span class="delivery-method__price old_price">{{
                            deliveries.world_delivery_tax.inclusive
                        }} {{ deliveries.world_delivery_tax.currency_sign }}</span>

                </template>
                <template v-if="!deliveries.world_delivery_tax.inclusive">
                    - <span class="delivery-method__price ">{{
                        deliveries.world_delivery_tax.price
                    }} {{ deliveries.world_delivery_tax.currency_sign }} </span>

                </template>
            </div>
            <div class="delivery-method__info" v-else>
                <span class="order-page__select-option__description"></span>
                <span class="order-page__select-option__description">{{ trans('Not defined') }}</span>
            </div>
        </div>
        <div v-if="deliveries.cdek_courier?.name">
            <div class="order-page__select-option order-page__select-option_active">
                <div class="radio-button">
                    <div style="position: relative;">
                        <input v-model="method" id="cdek_courier" name="order[delivery_method]"
                               class="radio-button__input"
                               type="radio"
                               value="cdek_courier">
                        <label @click="method = 'cdek_courier';pvz = false" for="cdek_courier"
                               class="radio-button__label"></label>
                    </div>
                    <span class="radio-button__title">{{ trans('Courier delivery of SDEC') }}</span>
                </div>

            </div>
            <div class="delivery-method__info" v-if="deliveries.cdek_courier">
                <span class="order-page__select-option__description"></span>
                <span class="order-page__select-option__description">{{ deliveries.cdek_courier.str }}</span>
                - <span class="delivery-method__price">{{
                    deliveries.cdek_courier.price
                }} {{ deliveries.cdek_courier.currency_sign }}</span>
            </div>
            <div class="delivery-method__info" v-else>
                <span class="order-page__select-option__description"></span>
                <span class="order-page__select-option__description">{{ trans('Not defined') }}</span>
            </div>
        </div>
        <div v-if="deliveries.cdek_pvz?.name">
            <div class="order-page__select-option order-page__select-option_active">
                <div class="radio-button">
                    <div style="position: relative;">
                        <input id="cdek_pvz" name="order[delivery_method]" class="radio-button__input"
                               v-model="method" type="radio" value="cdek_pvz">
                        <label @click="method = 'cdek_pvz';getMarkers()" for="cdek_pvz"
                               class="radio-button__label"></label>
                    </div>
                    <span class="radio-button__title">{{ trans("Courier delivery of SDEK PVZ") }}</span>
                </div>


                <div class="delivery-method__info" v-if="deliveries.cdek_pvz">
                    <span class="order-page__select-option__description"></span>
                    <span class="order-page__select-option__description">{{ deliveries.cdek_pvz.str }}</span>
                    - <span class="delivery-method__price">{{
                        deliveries.cdek_pvz.price
                    }} {{ deliveries.cdek_pvz.currency_sign }}</span>
                </div>
                <div class="delivery-method__info" v-else>
                    <span class="order-page__select-option__description"></span>
                    <span class="order-page__select-option__description">{{ trans('Not defined') }}</span>
                </div>
                <div class="delivery-method__info" style="width: 70%;" v-if="pvzObject">

                    <span class="order-page__select-option__description">
                        {{ pvzObject.address_full }}</span>
                </div>


            </div>
        </div>

        <div class="air-container  air-container-pvz" :class="pvz  ?'air-container_active':''">
            <div class="popup-air " :class="pvz ?'popup-air_active':''" style="height: 640px; width: 70%;">
                <div class="air-close" @click="pvz = false ;alertPvz()"></div>
                <div id="stores-map"></div>
            </div>
        </div>


        <div v-if="deliveries.russian_post?.name">
            <div class="order-page__select-option order-page__select-option_active">
                <div class="radio-button">
                    <div style="position: relative;">
                        <input id="russian_post" name="order[delivery_method]" class="radio-button__input"
                               v-model="method" type="radio"
                               value="russian_post">
                        <label @click="method = 'russian_post';pvz = false" for="russian_post"
                               class="radio-button__label"></label>
                    </div>
                    <span class="radio-button__title">{{ trans("Courier delivery by Russian Post") }}</span>
                </div>
                <div class="delivery-method__info" v-if="deliveries.russian_post">
                    <span class="order-page__select-option__description"></span>
                    <span class="order-page__select-option__description">{{ deliveries.russian_post.str }}</span>
                    - <span class="delivery-method__price">{{
                        deliveries.russian_post.price
                    }} {{ deliveries.russian_post.currency_sign }}</span>
                </div>
                <div class="delivery-method__info" v-else>
                    <span class="order-page__select-option__description"></span>
                    <span class="order-page__select-option__description">{{ trans('Not defined') }}</span>
                </div>
            </div>
        </div>
        <div v-if="deliveries.stores">
            <div class="order-page__select-option order-page__select-option_active" v-for="stores in deliveries.stores">
                <div class="radio-button">
                    <div style="position: relative;">

                        <input  name="order[delivery_method]" class="radio-button__input"
                                v-model="method" type="radio"
                                :value="stores.id">

                        <label @click="method = stores.id;pvz = false" :for="stores.id"
                               class="radio-button__label"></label>
                    </div>
                    <span class="radio-button__title">{{ stores.name }}</span>
                </div>
                <div class="delivery-method__info" >
                    <span class="order-page__select-option__description"></span>
                    <span class="order-page__select-option__description">{{ stores.str }}</span>
                    - <span class="delivery-method__price">{{
                        stores.price
                    }} </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/loading.vue'
export default {
    components: {
        Loading
    },
    data() {
        return {
            loading: true,
            pvz: false,
            pvzObject: false,
            method: null,
            myMap: null,
            myMarkers: null,
            deliveries: [],
            city_id: this.$store.state.settings.delivery_city?.id,
            city_id_pvz: null
        }
    },
    methods: {
        alertPvz() {
            this.pvzObject = this.setPvz(this.$store.state.settings.delivery_city.pvz)
        },
        setPvz(pvz) {
            return this.myMarkers.find(item => item.id === pvz)
        },
        async getMarkers() {

            this.city_id_pvz = this.city_id
            await axios.get('/api/v1/get-markers-pvz', {
                params: this.setParam({
                    city_id: this.city_id ?? this.$store.state.settings.delivery_city?.id,
                })
            })
                .then(data => {
                    this.myMarkers = data.data

                }).then(() => {
                    this.getInit()
                }).then(data => {
                    this.pvz = true
                })


        },
        getInit() {

            let myMap;

            $('#stores-map').empty()
            myMap = new ymaps.Map('stores-map', {
                center: [this.myMarkers[0].latitude, this.myMarkers[0].longitude],
                zoom: 12,
                behaviors: ['default', 'scrollZoom']
            }, {
                searchControlProvider: 'yandex#search'
            });
            let geoObjects;
            let clusterer;

            clusterer = new ymaps.Clusterer({

                preset: 'islands#invertedGreenClusterIcons',
                /**
                 * Ставим true, если хотим кластеризовать только точки с одинаковыми координатами.
                 */
                groupByCoordinates: false,

                clusterDisableClickZoom: true,
                clusterHideIconOnBalloonOpen: false,
                geoObjectHideIconOnBalloonOpen: false
            }),

                geoObjects = [];


            $.each(this.myMarkers, function (key, value) {

                geoObjects[key] = new ymaps.Placemark([value.latitude, value.longitude], {

                    myid: value.id,
                    balloonContentHeader: value.title,
                    balloonContentBody: value.address,
                    balloonContentFooter: "адрес: " + value.address + "<br> телефон: <a href='tel:" + value.phone + "'>" + value.phone + "</a><br> Режим работы: " + value.work_time + "<br> " +
                        "<button  value='" + value.id + "' class='pvz-id' data-pvz='" + value.id + "' type='button' >Выбрать</button>",
                    hintContent: value.title,
                    clusterCaption: ' <strong>' + value.address + '</strong>'
                }, {

                    iconLayout: 'default#imageWithContent',

                    iconImageHref: 'https://batnorton.com/img/sdek.png',

                    iconImageSize: [48, 48],

                    iconImageOffset: [-24, -24],

                    iconContentOffset: [15, 15],


                })

            });


            clusterer.add(geoObjects);
            myMap.geoObjects.add(clusterer);


            clusterer.events.add('click', function onObjectEvent(e) {

                var coords = e.get("coords");

                myMap.zoomRange.get(coords).then(function (range) {
                    myMap.setCenter(
                        coords,
                        myMap.getZoom() + 2
                    );
                });


            })
            // myMap.setBounds(clusterer.getBounds(), {
            //     checkZoomRange: true,
            //     zoomMargin:12
            // });


        }
    },
    mounted() {
        let settingsSite = this.$store.state.settings.fieldsFormSite[this.$store.state.settings.site_id];
        this.method = settingsSite.deliveriesMethods
    },
    name: "deliveries",
    watch: {
        method(newVal, oldVal) {
            if (newVal === oldVal) return;
            this.$parent.deliveriesMethod = this.method
            if (this.method !== 'cdek_pvz') {
                this.$parent.pvz = null
                if (this.$store.state.settings.delivery_city) {
                    this.$store.state.settings.delivery_city.pvz = null
                }
            }
        },
        city_id() {
            this.$parent.getDelivery()
            if (this.$store.state.settings.delivery_city) {
                this.$store.state.settings.delivery_city.pvz = null
            }
            this.pvzObject = null
        },
        deliveries: {
        handler(newDeliveries) {
            if (!newDeliveries || typeof newDeliveries !== 'object') return
            const defaultMethod = this.$store.state.settings?.fieldsFormSite?.[this.$store.state.settings?.site_id]?.deliveriesMethods
            const hasMethod = (m) => {
                if (newDeliveries[m]?.name) return true
                if (Array.isArray(newDeliveries.stores)) return newDeliveries.stores.some(s => String(s.id) === String(m))
                return false
            }
            if (!hasMethod(this.method)) {
                this.method = hasMethod(defaultMethod) ? defaultMethod : (Object.keys(newDeliveries).find(k => k !== 'stores' && newDeliveries[k]?.name) ?? (newDeliveries.stores?.[0]?.id ?? null))
                if (this.method != null) this.$parent.deliveriesMethod = this.method
            }
        },
        deep: true
    }
    }
}
</script>

<style scoped>
.color-red {
    color: red;
}

.old_price {
    color: #9b9fa1;
    -webkit-text-decoration-line: line-through;
    text-decoration-line: line-through;
    margin-left: 10px;
}
</style>
